import { reactive } from 'vue';
import i18n from '../../../../i18n';
import { createLoading } from '../../../../utils/loading';
import {
    createManageExportCsv,
    createManageSelect,
    createPage
} from '../../../../utils/page';
import {
    createColumnDate, createColumnInlineTextArea, createColumnInput,
    createColumnInputNumber,
    createColumnSelect
} from '../../../../components/table/c-table.logic';
import store from '../../../../store';
import lodash from 'lodash';
import { getLabTopicByLabTypeKey } from '../../master-mgt/lab/lab-share.logic';
import { callLabTopic } from '../../master-mgt/lab/sampling-monitor-type-lab-topic/sampling-monitor-type-lab-topic.logic';
import { callSearchSamplingProductAnalysis } from './export-product-topic-report.logic';
import {
    callSamplingMonitorSourceType, callSamplingMonitorSpecies,
    callSamplingMonitorType
} from '../../master-mgt/sampling-monitor-product/sampling-monitor-product.logic';
import { callDepartmentFisherOther } from '../../sampling-monitor/sampling-monitor/sampling-monitor.section';


const callDepartment = ({ searchQuery, refLabTypeKey }) =>
    store.dispatch("resource/v1/master/department/cacheFindAll", {
        searchQuery,
        where: [
            { name: "refDepartmentType.key", type: "String", operator: "=", value: "LAB" },
            { name: "refLabType.key", type: "String", operator: "=", value: refLabTypeKey }
        ]
    });

export const callSearchSamplingMonitorProduct = ({ criteria }) => store.dispatch(`resource/v1/master/samplingMonitorProduct/search`, { criteria });
export const callLabResultStatus = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "ACCEPT_STATUS", value: searchQuery });

export const { isLoading, setIsLoading } = createLoading();

export const onSearch = ({ page, props }) => {

    setIsLoading(true);

    const { where = [] } = page;
    const sort = page.sort || [];
    window.onSearch?.({ page });

    const customWhere = lodash.cloneDeep(where);
    const children = [{
        select: ['*',
            'refLabTopic.id',
            'refLabTopic.name',
            'refLabTopic.nameS',
            'refTopicAnalysisStatus.*'
        ],
        name: 'topics',
        page: 0,
        size: 1000,
        children: [{
            select: ['id'],
            name: 'transferTos',
            page: 0,
            size: 1000
        }, {
            select: ['realValue', "refAcceptanceStatus.*"],
            name: 'inputs',
            page: 0,
            size: 1000,
            children: [{
                select: ['*', 'refResultStatus.*'],
                name: 'results',
                page: 0,
                size: 1
            }]
        }],
    }]

    const topicIndex = customWhere.findIndex(d => d.name?.startsWith("refLabTopic.id"));

    if (topicIndex !== -1) {
        const whereTopic = lodash.cloneDeep(customWhere[topicIndex]);
        customWhere.splice(topicIndex, 1);
        const topicWhere = children.find(it => it.name == 'topics')
        if (topicWhere.value.length) {
            children.where.push({ ...whereTopic })
        }
    }

    return callSearchSamplingProductAnalysis({
        criteria: {
            ...page,
            where: [
                ...customWhere,
                { name: 'refLabType.key', type: 'String', operator: '=', value: props.refLabTypeKey, },
                { name: 'refSamplingProduct.refSamplingRequest.refSamplingRequestType.key', type: 'String', operator: 'in', value: ['M'] },
                { name: 'refLabResultStatus.key', type: "String", operator: "in", value: ["Reject", "Accept"] }
            ],
            children,
            data: []
        }
    }).then(page => {
        page.data.forEach(analysis => {
            let remark = ""
            analysis.topics = analysis.topics.filter(topic => topic.transferTos.length  == 0).map(analysisTopic => {
                lodash.set(analysisTopic.refLabTopic, "count", 1)
                lodash.set(analysis, analysisTopic?.refLabTopic?.id, analysisTopic?.refLabTopic)
                if(analysisTopic.refTopicAnalysisStatus.key == 'Reject') {
                    const topicName = analysisTopic.refLabTopic.nameS;
                    let realValues = [];
                    analysisTopic.inputs.forEach(input => {
                        if (input.results[0]?.refResultStatus?.key  == 'Reject') {
                            realValues.push(input.displayValue)
                        }
                    })
                    remark = `[${topicName + ' = ' + realValues.join(",")}]`
                }
            });
            lodash.set(analysis, "remark", remark)

            /* const labDeptId = analysis.refDepartment?.id ? analysis.refDepartment?.id : analysis.refLabExt?.id
             const companyId = analysis.refSamplingProduct?.refRequesterDepartment?.refCompany?.id
             const productId = analysis.refSamplingProduct?.refCompanyProduct?.refProduct?.id
             const combineGroupId = labDeptId + companyId + productId;
             analysis.combineGroupId = combineGroupId;
             const index = reportDatas.findIndex(it => it.combineGroupId == analysis.combineGroupId)
             if (index > -1) {
                 analysis.topics?.forEach(analysisTopic => {
                     if (!lodash.get(reportDatas[index], analysisTopic.refLabTopic.id)) {
                         analysisTopic.refLabTopic.count = 1;
                         lodash.set(reportDatas[index], analysisTopic.refLabTopic.id,  analysisTopic.refLabTopic);
                     } else {
                         lodash.get(reportDatas[index],  analysisTopic.refLabTopic.id).count += 1
                     }
                 })
             } else {
                 analysis.topics.forEach(analysisTopic => {
                     lodash.set(analysisTopic.refLabTopic, "count", 1)
                     lodash.set(analysis, analysisTopic.refLabTopic.id, analysisTopic.refLabTopic)
                 })
                 reportDatas.push(analysis)
             }*/
        })
        state.page = { ...page, where, sort }
        // state.page = { data: [...reportDatas],
        //     page: 0,
        //     size: 1000,
        // };
    }).finally(() => setIsLoading(false));
};



export const createColumns = ({ props }) => {
    const { refLabTypeKey } = props;

    if (state.columns.length == 0) {
        getLabTopicByLabTypeKey({ labTypeKey: props.refLabTypeKey }).then(topics => {
            state.columns.push(createColumnSelect({
                visible: () => false,
                title: () => i18n.global.t("views.report.labMicro.exportProductTopicReport.department"),
                dataIndex: "refDepartment.nameTh",
                customRender: ({ record }) => {
                    return <div>{record?.refDepartment?.nameTh || record?.refLabExt?.nameTh}</div>
                },
                inputProp: () => ({
                    list: ({ searchQuery }) => callDepartment({ searchQuery, refLabTypeKey }).then(list => list),
                    optLabel: "nameTh"
                }),
                search: { name: "refDepartment.id" },
                fixed: 'left',
            })),
            state.columns.push(createColumnSelect({
                    visible: () => false,
                    title: () => i18n.global.t("views.report.labMicro.exportProductTopicReport.refRequesterDepartment"),
                    dataIndex: "refRequesterDepartment.nameTh",
                    customRender: ({ record }) => {
                        return <div>{record?.refDepartment?.nameTh || record?.refLabExt?.nameTh}</div>
                    },
                    inputProp: () => ({
                        list: callDepartmentFisherOther,
                        optLabel: "nameTh"
                    }),
                    search: { name: "refDepartment.id" },
                    fixed: 'left',
                })),
            state.columns.push(createColumnInput({
                title: () => i18n.global.t('views.report.labMicro.monitorProductTopicReport.samplingNo'),
                dataIndex: 'refSamplingProduct.samplingNo',
                align: 'center',
                fixed: 'left',
            })),
            state.columns.push(createColumnInput({
                title: () => i18n.global.t('views.report.labMicro.monitorProductTopicReport.samplingNameTh'),
                dataIndex: 'refSamplingProduct.samplingNameTh',
                align: 'center',
                fixed: 'left',
            })),
            state.columns.push(createColumnSelect({
                visible: () => false,
                title: () => i18n.global.t('views.report.labMicro.monitorProductTopicReport.refRequesterDepartment'),
                dataIndex: 'refSamplingProduct.refSamplingRequest.refRequesterDepartment.nameTh',
                align: 'center',
                inputProp: () => {
                    return {
                        list: ({ searchQuery }) => {
                            const where = [
                                { name: "isActive", type: "Boolean", operator: "=", value: true },
                                { name: "refParent.id", type: "UUID", operator: "=", value: null },
                                { name: "refDepartmentType.key", type: "String", operator: "in", value: ['FIQC', 'FIRC'] }
                            ]
                            if (searchQuery) {
                                where.push({ name: "nameTh", type: "String", operator: "like", value: searchQuery });
                                where.push({ name: "nameEn", type: "String", operator: "like", value: searchQuery });
                            }
                            return store.dispatch("resource/v1/master/department/search", { criteria: { select: ["**"], page: 0, size: 1000000, where: [...where] } }).then(page => {
                                return page.data
                            })
                        },
                        renderLabel: ({ item }) => <div>{item?.nameTh}</div>,
                    };
                },
                fixed: 'left',
                search: {
                    visible: () => false,
                    name: 'refSamplingProduct.refSamplingRequest.refRequesterDepartment.id',
                }
            })),
            state.columns.push(createColumnDate({
                title: () => i18n.global.t('views.report.labMicro.monitorProductTopicReport.samplingCollectDate'),
                dataIndex: 'refSamplingProduct.refSamplingRequest.requestDate',
                format: 'DD/MM/YYYY',
                align: 'center',
                fixed: 'left',
            })),
            state.columns.push(createColumnDate({
                title: () => i18n.global.t('views.report.labMicro.monitorProductTopicReport.samplingReceiveDate'),
                dataIndex: 'samplingReceiveDate',
                format: 'DD/MM/YYYY',
                align: 'center',
                fixed: 'left',
            })),

            state.columns.push(createColumnSelect({
                visible: () => false,
                title: () => i18n.global.t("views.report.labMicro.monitorProductTopicReport.refSamplingMonitorType"),
                dataIndex: "refSamplingProduct.refSamplingMonitorType.name",
                inputProp: ({ field }) => {
                    return {
                        value: field.searchValue,
                        "onUpdate:value": value => (field.searchValue = value),
                        list: callSamplingMonitorType,
                        renderLabel: ({ item }) => <div>{item.name}</div>,
                    };
                },
                search: {
                    visible: () => true,
                    name: "refSamplingProduct.refSamplingMonitorType.id"
                },
                width: 180,
                align: "center",
                fixed: 'left',
            })),
            state.columns.push(createColumnSelect({
                visible: () => false,
                title: () => i18n.global.t("views.report.labMicro.monitorProductTopicReport.refSamplingMonitorSpecies"),
                dataIndex: "refSamplingProduct.refSamplingMonitorSpecies.value",
                inputProp: ({ field }) => {
                    return {
                        value: field.searchValue,
                        "onUpdate:value": value => (field.searchValue = value),
                        list: callSamplingMonitorSpecies,
                        renderLabel: ({ item }) => <div>{item.name}</div>,
                    };
                },
                align: "center",
                fixed: 'left',
                search: {
                    visible: () => true,
                    name: 'refSamplingProduct.refSamplingMonitorSpecies.id',
                }
            })),
            state.columns.push(createColumnSelect({
                visible: () => false,
                title: () => i18n.global.t("views.report.labMicro.monitorProductTopicReport.refSamplingMonitorSourceType"),
                dataIndex: "refSamplingProduct.refSamplingMonitorSourceType.value",
                customRender: ({ record }) => <div>{record.refSamplingMonitorSourceType?.value}</div>,
                inputProp: ({ field }) => {
                    return {
                        value: field.searchValue,
                        "onUpdate:value": value => (field.searchValue = value),
                        list: callSamplingMonitorSourceType,
                        renderLabel: ({ item }) => <div>{item.value}</div>,
                    };
                },
                align: "center",
                fixed: 'left',
                search: {
                    visible: () => true,
                    name: 'refSamplingProduct.refSamplingMonitorSourceType.id',
                }
            })),
                state.columns.push(createColumnSelect({
                title: () => i18n.global.t('views.report.labMicro.monitorProductTopicReport.refLabResultStatus'),
                dataIndex: 'refLabResultStatus.value',
                inputProp: ({ field }) => {
                    return {
                        value: field.searchValue,
                        "onUpdate:value": value => (field.searchValue = value),
                        list: ({ searchQuery }) => {
                            return callLabResultStatus({ searchQuery }).then(list => list?.filter(it => it.key != 'RejectCanRepeat'))
                        },
                        optLabel: "value"
                    };
                },
                align: "center",
                fixed: 'left',
                search: {
                    visible: () => true,
                    name: 'refLabResultStatus.id',
                }
            })),
            state.columns.push(createColumnSelect({
                title: () => i18n.global.t('views.report.labMicro.monitorProductTopicReport.labTopic'),
                visible: () => false,
                inputProp: () => ({
                    list: ({ searchQuery }) => callLabTopic({ searchQuery, labTypeKey: props.refLabTypeKey }),
                    mode: "multiple",
                }),
                search: {
                    visible: () => true,
                    name: "refLabTopic.id",
                    operator: "in",
                    getValue: ({ value }) => value.map(d => d.id),
                    field: { searchValue: [] }
                },
                align: "center"
            })),
            topics.forEach(topic => {
                state.columns.push(createColumnInputNumber({
                    title: () => topic.nameS,
                    dataIndex: `${topic.id}.count`,
                    align: 'center',
                    search: { visible: () => false },
                    sorter: false,
                }))
            }),
            state.columns.push(createColumnInlineTextArea({
                title: () => i18n.global.t("views.report.labMicro.monitorProductTopicReport.remarkReject"),
                dataIndex: "remark",
                customRenderInputProp: () => ({ disabled: true }),
                search: { visible: () => false },
                fixed: 'right',
            }))
        });
    }
};
export const state = reactive({
    columns: [],
    page: createPage({
        options: {
            select: [
                '**',
                'refCreateBy.fullName',
                'refSamplingProduct.refCountry1.*',
                'refSamplingProduct.refCountry2.*',
                'refSamplingProduct.refSamplingRequest.*',
                'refSamplingProduct.refSamplingRequest.refRequesterDepartment.*',
                'refSamplingProduct.refSamplingMonitorProduct.refSamplingMonitorProduct.*',
                'refSamplingProduct.refSamplingMonitorProduct.refSamplingMonitorProduct.refSamplingMonitorType.*',
                'refSamplingProduct.refSamplingMonitorProduct.refSamplingMonitorProduct.refSamplingMonitorSpecies.*',
                'refSamplingProduct.refSamplingMonitorProduct.refSamplingMonitorProduct.refSamplingSourceType.*',
            ],
            page: 0,
            size: 100000000
        }
    }),
    tableOptions: { search: { activeKey: 'Search' } }
});

export const initState = ({ props, data }) => {
    const menuContext = props.menuContext;
    createColumns({ props, data });
    state.manages = [
        createManageSelect({ menuContext }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [];
};



